import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./ArchivosClinicos.css";

function ModalAyudasDiagnosticasProximamente({ show, onHide }) {
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            dialogClassName="modal-ayudas-proximo"
        >
            <Modal.Body className="text-center px-4 py-5">
                <div className="modal-ayudas-proximo-icon mb-3">
                    <i className="fas fa-images" />
                </div>
                <p className="modal-ayudas-proximo-eyebrow mb-1">Próximamente</p>
                <h4 className="modal-ayudas-proximo-title mb-3">
                    Módulo de Imágenes y Documentos
                </h4>
                <p className="text-muted mb-4 px-2">
                    Almacene radiografías, fotografías clínicas y PDFs por paciente desde la atención.
                    <br />
                    Comunicate con tu Proveedor para Activar este Modulo.
                </p>
                <Button className="archivos-btn-guardar text-white px-4" onClick={onHide}>
                    Entendido
                </Button>
            </Modal.Body>
        </Modal>
    );
}

export default ModalAyudasDiagnosticasProximamente;
